// Code 128 / GS1-128 encoder producing module widths (bar,space,bar,...) for vector rendering.
const P = [
  "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
  "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
  "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
  "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
  "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
  "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
  "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
  "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
  "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
  "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
  "114131", "311141", "411131", "211412", "211214", "211232",
];
const STOP = "2331112";

const widthsFromCodes = (codes) => {
  let sum = codes[0];
  for (let i = 1; i < codes.length; i++) sum += codes[i] * i;
  const widths = [];
  for (const c of [...codes, sum % 103]) for (const ch of P[c]) widths.push(Number(ch));
  for (const ch of STOP) widths.push(Number(ch));
  return widths;
};

// data: any string. Pure even-length digits use subset C, otherwise subset B.
export const barcodeWidths = (data, { gs1 = false } = {}) => {
  const str = String(data || "");
  const codes = [];
  if (/^\d+$/.test(str) && str.length % 2 === 0) {
    codes.push(105);
    if (gs1) codes.push(102);
    for (let i = 0; i < str.length; i += 2) codes.push(Number(str.slice(i, i + 2)));
  } else {
    codes.push(104);
    if (gs1) codes.push(102);
    for (const ch of str) codes.push(ch.charCodeAt(0) - 32);
  }
  return widthsFromCodes(codes);
};

export const barcodeSvg = (widths, height = 60) => {
  const total = widths.reduce((a, b) => a + b, 0) + 20;
  let x = 10;
  let rects = "";
  widths.forEach((w, i) => {
    if (i % 2 === 0) rects += `<rect x="${x}" y="0" width="${w}" height="${height}"/>`;
    x += w;
  });
  return `<svg viewBox="0 0 ${total} ${height}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%;display:block">${rects}</svg>`;
};
